<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="EquipmentId"
      ref="list"
      unit="设备"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="true"
      :get-data-func="getDataWithUsers"
      :query-params="params"
      :showTrendTable="showTrendTable"
      urlHash="facility/manage"
      @check-change="onCheckChange"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <!-- 大屏用户列 -->
        <el-table-column label="大屏用户" align="center" width="150">
          <template slot-scope="{ row }">
            <span>{{ row.ScreenUserNames || '-' }}</span>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/ba/equipment").default,
      screenUserApi: require("@/api/ba/equipmentScreenUser").default,
      params: {
        JobName: "",
        Status: null,
      },
      equipmentWithUsers: [],
    };
  },
   props: {
    showTrendTable: {
      type: Boolean,
      default: true
    },
    modelType: {
      type: String,
      default: ''
    }
  },
  mounted() {
    //this.loadEquipmentWithUsers();
  },
  methods: {
    // 加载设备及大屏用户列表
    loadEquipmentWithUsers() {
      this.screenUserApi.getEquipmentListWithUsers().then(res => {
        if (res.Code == 0) {
          this.equipmentWithUsers = res.Data || [];
        }
      });
    },
    // 获取数据并添加大屏用户信息
    getDataWithUsers(params) {
      /*
      return this.api.list(params).then(res => {
        if (res.Code == 0 && res.Data && res.Data.length > 0) {
          // 合并大屏用户信息
          res.Data.forEach(item => {
            const equipment = this.equipmentWithUsers.find(e => e.EquipmentId === item.EquipmentId);
            if (equipment) {
              this.$set(item, 'ScreenUserNames', equipment.ScreenUserNames);
            } else {
              this.$set(item, 'ScreenUserNames', '');
            }
          });
        }
        return res;
      });
      */
       return this.screenUserApi.getEquipmentListWithUsers(params).then(res => {
        if (res.Code == 0) {
          // 数据已经包含 ScreenUserNames，无需额外处理
          return res;
        }
        return res;
      });
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.export(this.params).then(() => {
        loading.close();
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    reload() {
      this.getData();
      //this.loadEquipmentWithUsers();
    },
    onCheckChange(selection) {
    this.$emit('selRowData', selection);
  },
  },
};
</script>